import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './pages/Home';
import './style/Home.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Home />);
